// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__3HV3m","item":"items_list_item__3WdhZ"};